import React from 'react';
import { Tooltip, TooltipProps, Typography } from '@mui/material';
import { Box, SxProps } from '@mui/system';
import { COLORS } from 'components';
import { InfoIcon } from 'assets';

export const InfoLabel = ({
    title,
    infoMessage,
    labelSx,
    titleSx,
    tooltipSx,
    placement,
}: { title?: string, infoMessage: string, labelSx?: SxProps, titleSx?: SxProps, tooltipSx?: SxProps, placement?: TooltipProps["placement"] }) => (
    <Tooltip placement={placement || 'top-start'} arrow title={infoMessage} slotProps={{ tooltip: { sx: tooltipSx } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', padding: '8px 10px', cursor: 'pointer', minWidth: 'fit-content', borderRadius: '8px', background: '#E5EAF3', ...labelSx }}>
            <InfoIcon color={COLORS.Romance} />
            {title && <Typography sx={{ color: COLORS.Romance, fontSize: '14px', fontWeight: '600', ...titleSx }}>
                {title}
            </Typography>}
        </Box>
    </Tooltip>
)